/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Surviving source this source was merged into. Absent when it was never merged.
 * @export
 * @interface GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource
 */
export interface GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource interface.
 */
export function instanceOfGetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource(value: object): value is GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceFromJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource {
    return GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceFromJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceToJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource {
    return GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceToJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceToJSONTyped(value?: GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

